module.exports = "<div class=\"body l-wrap\"></div>\n"